<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";

// Custom Components
import PageHeader from "@/components/page-header";
import StaffForm from "@/components/staff-form.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import Middleware from "@/helpers/middlewares";
import appConfig from "@/app.config";

// Staff Component

export default {
  page: {
    title: "Staff",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    PageHeader,
    StaffForm,
  },
  data() {
    return {
      title: "Staff",
      isLoading: true,
      openNewStaffForm: false,
      table: {
        tableData: [],
      },
      selectedStaff: null,
      isEdit: false,
    };
  },
  computed: {
    ...authComputed,
    rows() {
      return this.tableData.length;
    },
    staffFormProps() {
      return {
        selectedStaff: this.selectedStaff,
        isEdit: this.isEdit,
      };
    },
  },
  mounted() {
    this.getStaffs();
  },
  methods: {
    getStaffs() {
      UserService.getStaffList()
        .then((staffs) => {
          this.table.tableData = staffs;
          this.isLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    newStaffForm() {
      if (this.openNewStaffForm === true) {
        this.isEdit = false;
        this.selectedStaff = null;
      }
      this.openNewStaffForm = !this.openNewStaffForm;
    },
    editStaff(data) {
      this.selectedStaff = data;
      this.isEdit = true;
      this.newStaffForm();
    },
    staffAddedUpdated(data) {
      if (this.isEdit == true) {
        this.table.tableData = this.table.tableData.map((obj) => {
          if (obj.id == data.id) {
            obj = data;
          }
          return obj;
        });
        Middleware.notification("Successfully updated !!", "success");
      } else {
        this.table.tableData.unshift(data);
        Middleware.notification("Successfully added !!", "success");
      }
      this.newStaffForm();
    },
    saveAndAddNewStaff(staff) {
      this.table.tableData.unshift(staff);
      Middleware.notification("Successfully added !!", "success");
    },
    changeStaffStatus(data) {
      let staffData = new FormData();
      staffData.append("is_active", data.is_active);
      staffData.append("is_staff", data.is_active);
      UserService.editStaff(data.id, staffData)
        .then(() => {
          Middleware.notification("Successfully changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    deleteStaff(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteStaff(id).then(
            () => {
              let index = this.table.tableData.findIndex((el) => el.id === id);
              this.table.tableData.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "danger");

              this.isLoading = false;
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="newStaffForm"
      text="Add New Staff"
      :isButton="true"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <!-- Table -->
                <div class="table-responsive mb-0" v-dragscroll>
                  <table
                    class="table table-hover mb-0"
                    ref="my-table"
                    v-infinite-scroll="getStaffs"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="isLoading">
                      <tr v-for="item in 13" :key="item">
                        <td class="placeholder-glow" v-for="no in 7" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(data, index) in table.tableData" :key="index">
                        <td @click="editStaff(data)">
                          {{ data.first_name }}
                        </td>
                        <td @click="editStaff(data)">
                          {{ data.last_name }}
                        </td>
                        <td @click="editStaff(data)">
                          {{ data.email }}
                        </td>
                        <td @click="editStaff(data)">
                          {{ data.mobile }}
                        </td>
                        <td @click="editStaff(data)">
                          {{ data.role.name }}
                        </td>
                        <td>
                          <div
                            class="form-check form-switch my-1"
                            slot="is_active"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="data.is_active"
                              @change="
                                changeStaffStatus({
                                  id: data.id,
                                  is_active: data.is_active,
                                })
                              "
                            />
                          </div>
                        </td>
                        <td>
                          <div slot="actions" class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt text-success mx-1"
                              v-b-popover.hover="'Edit staff'"
                              @click="editStaff(data)"
                            ></i>
                            <i
                              class="mdi mdi-trash-can mx-1 text-danger fs-5"
                              v-b-popover.hover="'Delete staff'"
                              @click="deleteStaff(data.id)"
                            ></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Drawer
      @close="newStaffForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openNewStaffForm">
        <StaffForm
          :currentProps="staffFormProps"
          @submitted="staffAddedUpdated"
          @cancelSubmit="newStaffForm"
          @saveAndAddNew="saveAndAddNewStaff"
        />
      </div>
    </Drawer>
  </div>
</template>
